module.exports = __webpack_public_path__ + "static/img/mba-lean-flow.e8adbce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mba-lean-flow.png
// module id = QVfF
// module chunks = 2